import { Type } from "class-transformer";
import { IsNotEmpty, IsNumber, IsOptional, IsString } from "class-validator";

export class ProjectExpenseInvoiceLineDto {
    @IsNumber()
    @IsOptional()
    id!: number;

    @IsNumber()
    @IsOptional()
    position!: number;

    @IsString()
    @IsNotEmpty()
    concept!: string;

    @Type(() => Number)
    @IsNumber()
    @IsNotEmpty()
    base!: number;

    @Type(() => Number)
    @IsNumber()
    @IsNotEmpty()
    iva!: number;

    @Type(() => Number)
    @IsNumber()
    @IsNotEmpty()
    total!: number;
}

export interface ProjectExpenseInvoiceLineBody {
    concept: string;
    base: number;
    iva: number;
    total: number;
    position: number;
    id?: number | undefined;
}
